
    <div class="invitation-card">
      <overlay-loading *ngIf="loading"></overlay-loading>

      <div class="invites-container" [class.full-height]="myInvites.length">
        <div class="card-title">Convites aceitos</div>

        <div *ngIf="!myInvites.length" class="without-invitations">
          Quando alguém aceitar o seu convite, aparecerá listado aqui para você acompanhar.
        </div>

        <div *ngFor="let invite of myInvites" class="invitation-item">
          <div class="invitation-info">
            <b>{{invite.receiverName}}</b>
            Aceito em: {{invite.created_at | date:"dd/MM/yy"}}
          </div>
          <div class="status">
            <span class="fa fa-check"></span>
            Aceito
          </div>
        </div>
      </div>
      <button *ngIf="myInvites.length && !hideButton" (click)="redirectToInvites()" class="btn">Ver todos</button>
    </div>
  